<template>
  <div 
    ref="markdownContainer" 
    class="prose-custom text-slate-300 text-sm leading-relaxed p-4 overflow-y-auto h-full" 
    v-html="renderedHtml"
  ></div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue';
import { marked } from 'marked';

declare global {
  interface Window {
    renderMathInElement?: (el: HTMLElement, options?: any) => void;
  }
}

const props = defineProps<{
  content: string;
}>();

const markdownContainer = ref<HTMLDivElement | null>(null);

marked.setOptions({
  gfm: true,
  breaks: true,
});

const renderedHtml = computed(() => {
  if (!props.content) return '';
  return marked.parse(props.content);
});

function triggerMathRender() {
  nextTick(() => {
    if (markdownContainer.value && window.renderMathInElement) {
      try {
        window.renderMathInElement(markdownContainer.value, {
          delimiters: [
            { left: '$$', right: '$$', display: true },
            { left: '$', right: '$', display: false },
            { left: '\\(', right: '\\)', display: false },
            { left: '\\[', right: '\\]', display: true }
          ],
          throwOnError: false
        });
      } catch (e) {
        // ignore math parse errors
      }
    }
  });
}

watch(renderedHtml, () => {
  triggerMathRender();
}, { immediate: true });
</script>
